import { render } from "./EnhancedSkills.vue?vue&type=template&id=22fe8cf4&scoped=true"
import script from "./EnhancedSkills.vue?vue&type=script&lang=js"
export * from "./EnhancedSkills.vue?vue&type=script&lang=js"

import "./EnhancedSkills.vue?vue&type=style&index=0&id=22fe8cf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fe8cf4"]])

export default __exports__